import React from 'react';
import { IconProps } from '../types/types';

const USDJPY: React.FC<IconProps> = (props) => (
    <svg viewBox="0 0 40 41" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" {...props}>
        <path d="M14.002 26.398c7.193 0 13.025-5.832 13.025-13.025 0-7.194-5.832-13.025-13.025-13.025C6.808.348.977 6.179.977 13.373c0 7.193 5.831 13.025 13.025 13.025Z" fill="#F0F0F0" />
        <path
            d="M13.43 13.373H27.02c0-1.176-.157-2.315-.449-3.398H13.43v3.398ZM13.43 6.577h11.68a13.094 13.094 0 0 0-3.006-3.398H13.43v3.398ZM13.999 26.398c3.065 0 5.882-1.06 8.107-2.832H5.892a12.969 12.969 0 0 0 8.108 2.832ZM2.885 20.168h22.227a12.947 12.947 0 0 0 1.463-3.398H1.422a12.947 12.947 0 0 0 1.463 3.398Z"
            fill="#D80027"
        />
        <path
            d="M7.01 2.382h1.187l-1.104.802.422 1.298L6.41 3.68l-1.104.802.364-1.122a13.097 13.097 0 0 0-2.526 2.816h.38l-.703.51c-.11.183-.214.369-.315.557l.336 1.033-.627-.455a12.9 12.9 0 0 0-.425 1.011l.37 1.138h1.364l-1.104.802.422 1.298-1.104-.802-.662.48a13.15 13.15 0 0 0-.1 1.625h13.025V.348c-2.573 0-4.972.746-6.992 2.034Zm.505 9.688-1.104-.802-1.104.802.421-1.298-1.104-.802H5.99l.422-1.298.421 1.298h1.365l-1.104.802.422 1.298Zm-.422-5.092.422 1.298-1.104-.802-1.104.802.421-1.298-1.104-.802H5.99l.422-1.298.421 1.298h1.365l-1.104.802Zm5.094 5.092-1.104-.802-1.104.802.421-1.298-1.104-.802h1.365l.422-1.298.421 1.298h1.365l-1.104.802.422 1.298Zm-.422-5.092.422 1.298-1.104-.802-1.104.802.421-1.298-1.104-.802h1.365l.422-1.298.421 1.298h1.365l-1.104.802Zm0-3.794.422 1.298-1.104-.802-1.104.802.421-1.298-1.104-.802h1.365l.422-1.298.421 1.298h1.365l-1.104.802Z"
            fill="#0052B4"
        />
        <path
            d="M25.986 40.166c7.332 0 13.275-5.944 13.275-13.276 0-7.331-5.943-13.275-13.275-13.275-7.332 0-13.275 5.944-13.275 13.275 0 7.332 5.943 13.276 13.275 13.276Z"
            fill="#F0F0F0"
            stroke="#fff"
            strokeWidth={0.5}
        />
        <path d="M25.987 32.553a5.663 5.663 0 1 0 0-11.326 5.663 5.663 0 0 0 0 11.326Z" fill="#D80027" />
    </svg>
);

export default USDJPY;
